import React, { useState, useEffect, useRef } from "react";
import "./LabelCustomizer.scss";
import { Stage, Layer, Image } from "react-konva";
import Button from "./Button";
import FileInput from "./FileInput";
import {
  EditOutlined,
  FileImageOutlined,
  ShoppingCartOutlined,
  DownloadOutlined,
  ClearOutlined,
} from "@ant-design/icons";
import ImageContainer from "./ImageContainer";
import TextContainer from "./TextContainer";
import useImage from "use-image";
import useKeyPress from "../../hooks/useKeyPress";
import TextEditor from "../TextEditor";
import ThemePicker from "../ThemePicker";
import { Link } from "react-router-dom";
import BackgroundSelector from "./BackgroundSelector";
import { PictureOutlined } from "@ant-design/icons";
import { FaWineBottle } from "react-icons/fa";
import HelperChecklist from "./HelperChecklist";
import WineCard from "./WineCard";

const canvasSize = {
  height: "700",
  width: "514",
};

const LabelCustomizer = ({
  handleAddCart,
  useTemplate,
  setUseTemplate,
  products,
  setCurrentProduct,
  productID,
}) => {
  const [selectedId, selectShape] = useState(null);
  const [textElements, setTextElements] = useState([]);
  const [imgElements, setImgElements] = useState([]);
  const [showTemplate, setShowTemplate] = useState(false);
  const [previewMode, setPreviewMode] = useState(false);
  const [inLabelCustomizer, setInLabelCustomizer] = useState(true);
  const [addToCartConfirmation, setAddToCartConfirmation] = useState(false);
  const [addedToCart, setAddedToCart] = useState(false);
  const [showBackgrounds, setShowBackgrounds] = useState(false);
  const [showAddImage, setShowAddImage] = useState(false);
  const [isSelectingWine, setSelectingWine] = useState(false);
  const [checklistBg, setChecklistBg] = useState(false);
  const [checklistTxt, setChecklistTxt] = useState(false);
  const [checklistWine, setChecklistWine] = useState(false);
  const [openHelper, setOpenHelper] = useState(true);

  const deletePress = useKeyPress("delete");
  let canvas = useRef();
  let layer = useRef();
  let link = useRef();
  const [image] = useImage(useTemplate);

  const redDrawFont = () => {
    window.setTimeout(() => {
      layer.current.getLayer().draw();
    }, 150);
  };

  const closeEverything = () => {
    setShowAddImage(false);
    setShowBackgrounds(false);
    setShowTemplate(false);
    selectShape(null);
    setPreviewMode(false);
    setSelectingWine(false);
  };
  const handleAddImage = () => {
    closeEverything();
    setShowAddImage(true);
  };

  const handleImgUpload = (data) => {
    const id = "img" + assignUniqueID();
    let url = {
      URL: URL.createObjectURL(data[0]),
      id,
      x: 10,
      y: 10,
    };
    setImgElements([...imgElements, url]);
    setChecklistBg(true);
  };

  const assignUniqueID = () => {
    const randomID = Math.floor(Math.random() * 10000);
    return randomID;
  };

  const handleAddText = () => {
    closeEverything();
    const id = "text" + assignUniqueID();
    setTextElements([
      ...textElements,
      {
        x: 100,
        y: 100,
        id,
        text: "Your text goes here!",
        fontSize: 26,
      },
    ]);
    selectShape(() => id);
    setChecklistTxt(true);
  };

  const checkDeselect = (e) => {
    console.log("check deselecting");
    console.log(previewMode);
    if (previewMode) return false;
    const clickedOnEmpty = e.target === e.target.getStage();
    if (clickedOnEmpty) {
      selectShape(null);
    }
  };

  const prepareItemForCart = () => {
    const labelJPEG = canvas.getStage().toDataURL({
      mimeType: "image/jpeg",
      quality: 1.0,
      pixelRatio: 2,
    });
    handleAddCart(labelJPEG);
  };

  const bringToTopImage = (id) => {
    const items = imgElements.slice();
    const item = items.find((i) => i.id === id);
    const index = items.indexOf(item);
    // remove from the list:
    items.splice(index, 1);
    // add to the top
    items.push(item);
    setImgElements(items);
  };

  const handleDelete = () => {
    if (!selectedId) return;
    selectShape(null);
    if (selectedId.includes("text")) {
      const textElementsAfterDelete = textElements.filter(
        (item) => item.id !== selectedId
      );
      setTextElements(textElementsAfterDelete);
    } else {
      const imgElementsAfterDelete = imgElements.filter(
        (item) => item.id !== selectedId
      );
      setImgElements(imgElementsAfterDelete);
    }
  };

  useEffect(() => {
    if (deletePress) {
      handleDelete();
    }
  }, [deletePress]);

  const handleTextChange = (payload) => {
    const items = textElements.slice();
    const item = items.find((i) => i.id === selectedId);
    const index = items.indexOf(item);

    items[index] = { ...items[index], ...payload };

    setTextElements(items);
  };

  const handleDownload = async () => {
    selectShape(null);
    const a = link.current;
    const e = document.createEvent("MouseEvents");
    a.download = "download.jpeg";
    a.href = canvas.getStage().toDataURL({
      mimeType: "image/jpeg",
      quality: 1.0,
      pixelRatio: 2,
    });
    a.dataset.downloadurl = ["image/jpeg", a.download, a.href].join(":");
    e.initMouseEvent(
      "click",
      true,
      false,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    );
    a.dispatchEvent(e);
  };

  const handleTemplate = (value) => {
    setUseTemplate(value);
    setChecklistBg(true);
  };
  console.log("useTemplate", useTemplate);

  const handlePreview = () => {
    closeEverything();
    setPreviewMode(true);
  };

  // const handleAddToCartConfirmation = () => {
  //   setPreviewMode(false);
  //   setAddToCartConfirmation(true);
  // };

  const handleYesAddedToCart = () => {
    prepareItemForCart();
    setAddToCartConfirmation(false);
    setAddedToCart(true);
    setPreviewMode(false);
  };

  const handleCloseAddToConfirmation = () => {
    setAddToCartConfirmation(false);
    setPreviewMode(false);
  };

  // const continueShopping = () => {
  //   setCustomizing(false);
  //   setProductList(true);
  // };

  const handleAddWine = () => {
    closeEverything();
    setSelectingWine(true);
    setChecklistWine(true);
  };

  const handleMobileCanvas =
    window.innerWidth < 860 && showTemplate === true ? true : false;

  return (
    <div
      className="labelcustomizer"
      style={
        window.innerWidth < 860 && !previewMode
          ? { flexDirection: "column-reverse" }
          : null
      }
    >
      <div className="labelcustomizer-toolbar-left">
        {!previewMode && (
          <>
            <Button
              onClick={() => {
                const template = showTemplate;
                closeEverything();
                setShowTemplate(!template);
              }}
              text="Templates"
              Icon={FileImageOutlined}
              showButton={showTemplate}
            />
            <Button
              onClick={
                selectedId && selectedId.includes("text") ? "" : handleAddText
              }
              text="Add Text"
              Icon={EditOutlined}
              id="add-text"
              showButton={
                selectedId && selectedId.includes("text") ? true : false
              }
            />

            <Button
              onClick={handleAddImage}
              text="Add Image"
              Icon={PictureOutlined}
              id="add-image"
              showButton={showAddImage}
            />

            <Button
              text="Background"
              Icon={ClearOutlined}
              onClick={() => {
                const background = showBackgrounds;
                closeEverything();
                setShowBackgrounds(!background);
              }}
              showButton={showBackgrounds}
            />
            <Button
              onClick={handleAddWine}
              text="Pick a Wine"
              Icon={FaWineBottle}
              showButton={isSelectingWine}
            />

            {/* <Button onClick={handlePreview} text="Add to Cart" Icon={ShoppingCartOutlined} /> */}
          </>
        )}
      </div>
      {/* <div className="canvas-and-editor"> */}
      <div className="labelcustomizer-toolbar-right">
        {isSelectingWine &&
        <div className="wine-container">
          <h4>Please make sure you have completed your label BEFORE adding any wine to your cart</h4>
            {products.map((wine) => (
              <div className="wine-grid">
                <WineCard
                  wine={wine}
                  setCurrentProduct={setCurrentProduct}
                  handlePreview={handlePreview}
                />
              </div>
          ))}
          </div>
        }
        {showBackgrounds && !previewMode && (
          <div className="background-container">
            <h4>NOTE: If you have selected a template, this will not change the background of that template</h4>
            <BackgroundSelector handleTemplate={handleTemplate} />
          </div>
        )}

        {selectedId && selectedId.includes("text") && (
          <div className="text-editor">
            <div className="editor-buttons">
              <button onClick={handleAddText}>Add New Text</button>
              <button onClick={handleDelete}>Delete Selected Text</button>
            </div>
            <TextEditor
              handleTextChange={handleTextChange}
              selectedId={selectedId}
              textElements={textElements}
              redDrawFont={redDrawFont}
              selectShape={selectShape}
            />
          </div>
        )}
        {showAddImage && !previewMode && (
          <div>
            <FileInput value="" onChange={handleImgUpload} />
          </div>
        )}

        {showTemplate && !previewMode && (
          <div>
            <div className="template-picker-desktop">
              <ThemePicker
                inLabelCustomizer={inLabelCustomizer}
                handleTemplate={handleTemplate}
                setShowTemplate={setShowTemplate}
                showTemplate={showTemplate}
                display="desktop"
              />
            </div>
          </div>
        )}
        {/* </div> */}

        {previewMode && (
          <div className="preview-mode">
            <div className={`modal ${previewMode ? "is-active" : ""}`}>
              <div className="modal-background"></div>
              <div className="modal-card">
                <header className="modal-card-head">
                  Do you want to add this wine and your custom label to the
                  cart?
                </header>
                <footer className="modal-card-foot">
                  <button
                    className="add-to-cart-btn"
                    onClick={handleYesAddedToCart}
                  >
                    Yes
                  </button>
                  <button
                    className="add-to-cart-btn"
                    onClick={handleCloseAddToConfirmation}
                  >
                    Go Back
                  </button>
                  <button
                    onClick={handleDownload}
                    // text="Download"
                    // Icon={DownloadOutlined}
                  >
                    <DownloadOutlined />
                    <a href="#" ref={link} style={{ display: "none" }}>
                      download
                    </a>
                  </button>
                </footer>
              </div>
            </div>
          </div>
        )}

        {addedToCart && (
          <div className="added-to-cart-modal">
            <div className={`modal ${addedToCart ? "is-active" : ""}`}>
              <div className="modal-background"></div>
              <div className="modal-card">
                <header className="modal-card-head">
                  Your label and wine have been added to the cart!
                </header>
                <footer className="modal-card-foot">
                  <Link to="/cart">
                    <button className="add-to-cart-btn">View Your Cart</button>
                  </Link>
                  <button
                    className="add-to-cart-btn"
                    onClick={() => setAddedToCart(false)}
                  >
                    Make a new label or add another wine
                  </button>
                </footer>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="labelcustomizer-canvas" id="canvas">
        
        <Stage
          height={canvasSize.height}
          width={canvasSize.width}
          onMouseDown={checkDeselect}
          onTouchStart={checkDeselect}
          ref={(node) => (canvas = node)}
          style={{
            pointerEvents: previewMode ? "none" : "auto",
            display: handleMobileCanvas ? "none" : "block",
          }}
          className="stage"
        >
          <Layer ref={layer}>
            {useTemplate && (
              <Image
                image={image}
                height={canvasSize.height}
                width={canvasSize.width}
                crossOrigin="Anonymous"
                onMouseDown={() => selectShape(null)}
                onTouchStart={() => selectShape(null)}
              />
            )}
            {imgElements.map((img, i) => {
              return (
                <ImageContainer
                  shapeProps={img}
                  key={img.id}
                  isSelected={img.id === selectedId}
                  onSelect={() => {
                    selectShape(img.id);
                    bringToTopImage(img.id);
                  }}
                  onChange={(newAttrs) => {
                    const newImgElements = imgElements.slice();
                    newImgElements[i] = { ...newImgElements[i], ...newAttrs };
                    setImgElements(newImgElements);
                  }}
                  handleDelete={handleDelete}
                />
              );
            })}
            {textElements.map((text, i) => {
              return (
                <TextContainer
                  isSelected={text.id === selectedId}
                  shapeProps={text}
                  key={text.id}
                  onSelect={() => {
                    setShowBackgrounds(false);
                    setShowAddImage(false);
                    setSelectingWine(false);
                    setShowTemplate(false);
                    selectShape(text.id);
                  }}
                  onChange={(newAttrs) => {
                    const newTextElements = textElements.slice();
                    newTextElements[i] = {
                      ...newTextElements[i],
                      ...newAttrs,
                    };
                    setTextElements(newTextElements);
                  }}
                  handleDelete={handleDelete}
                />
              );
            })}
          </Layer>
        </Stage>
        <HelperChecklist openHelper={openHelper} setOpenHelper={setOpenHelper} checklistBg={checklistBg} checklistTxt={checklistTxt} checklistWine={checklistWine} />
      </div>

    </div>
  );
};

export default LabelCustomizer;
